function CardAlert({ title, description, date, category, onClick }) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  const getColor = (category) => {
    switch (category) {
      case "mantenimiento":
        return "#456882";
      case "capacitacion_vial":
        return "#F7AD45";
      case "capacitacion_plan_anual":
        return "#A35C7A";
      case "documentos_por_vencer":
        return "#88C273";
      case "documentacion":
        return "#88C273";
      default:
        return "#6b7280";
    }
  };

  const color = getColor(category);

  return (
    <div
      onClick={handleClick}
      style={{
        display: "flex",
        gap: "1rem",
        cursor: "pointer",
        border: "1px solid #e5e7eb",
        borderRadius: "0.5rem",
        padding: "1rem",
        backgroundColor: "#fff",
        boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
        transition: "transform 0.2s ease",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.01)")}
      onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
    >
      {/* Franja lateral */}
      <div
        style={{
          width: "6px",
          borderRadius: "6px",
          backgroundColor: color,
        }}
      />

      {/* Contenido */}
      <div style={{ flex: 1 }}>
        <h3 style={{ margin: 0, fontSize: "1rem", fontWeight: "bold" }}>
          {title}
        </h3>
        <p style={{ margin: "0.25rem 0", fontSize: "0.875rem" }}>
          {description}
        </p>
        <div
          style={{
            fontSize: "0.75rem",
            color: "#6b7280",
            display: "flex",
            justifyContent: "space-between",
            marginTop: "0.5rem",
          }}
        >
          <span>{date}</span>
          <span style={{ color }}>{category.split("_").join(" ")}</span>
        </div>
      </div>
    </div>
  );
}

export default CardAlert;
